import ajax from 'utils/ajax'
import API from 'api-url'
import Config from 'config'

class OpenService {
  // 获取图片信息
  imageFormat(url) {
    return ajax.get({
      url: API.open.imageFormat,
      data: {
        data: {
          image: url
        }
      }
    })
  }
  // 获取图片信息
  imgInfo(url) {
    return ajax.get({
      url: Config.imageUrl + url + '?avinfo'
    })
  }
  // 资源
  getCity(params) {
    return ajax.get({
      url: API.open.getCity,
      data: {
        data: params
      }
    })
  }

  chinaarea() {
    return ajax.get({
      url: API.open.chinaarea
    })
  }

  activitystatus(params) {
    return ajax.get({
      url: API.open.activitystatus,
      data: {
        data: params
      }
    })
  }

  studentValidate(params) {
    return ajax.post({
      url: API.open.studentValidate,
      data: params
    })
  }

  rechargeOrder(params) {
    return ajax.post({
      url: API.open.rechargeOrder,
      data: params
    })
  }

  vodSignature() {
    return ajax.post({
      url: API.open.vodSignature
    })
  }

  sysFeedback(params) {
    return ajax.post({
      url: API.open.sysFeedback,
      data: params
    })
  }

  getProvince() {
    return ajax.get({
      url: API.open.getProvince
    })
  }

  getProClass() {
    return ajax.get({
      url: API.open.professionClassification
    })
  }

  getProList(params) {
    return ajax.get({
      url: API.student.professionList,
      data: {
        data: params
      }
    })
  }

  // 专业详情
  majorDetail(id) {
    return ajax.get({
      url: API.open.majorDetail.format(id)
    })
  }

  // 专业下职业列表
  majorProfessionList(id, params) {
    return ajax.get({
      url: API.open.majorProfessionList.format(id),
      data: {
        data: params
      }
    })
  }

  // 专业下岗位列表
  majorPositionList(id, params) {
    return ajax.get({
      url: API.open.majorPositionList.format(id),
      data: {
        data: params
      }
    })
  }

  // 专业课程列表
  majorCourse(params) {
    return ajax.get({
      url: API.open.majorCourse,
      data: {
        data: params
      }
    })
  }

  // 我的专业课列表
  myMajorCourse(params) {
    return ajax.get({
      url: API.open.myMajorCourse,
      data: {
        data: params
      }
    })
  }

  // 专业课详情
  majorCourseId(id) {
    return ajax.get({
      url: API.open.majorCourseId.format(id)
    })
  }

  // 专业课程相关课程
  majorCourseVideo(id, params) {
    return ajax.get({
      url: API.open.majorCourseVideo.format(id),
      data: {
        data: params
      }
    })
  }

  // 签约人数
  majorStudents(id, params) {
    return ajax.get({
      url: API.open.majorStudents.format(id),
      data: {
        data: params
      }
    })
  }

  getKnowledgeList() {
    return ajax.get({
      url: API.open.getKnowledgeList
    })
  }

  getPointList(params) {
    return ajax.get({
      url: API.open.getPointList,
      data: {
        data: params
      }
    })
  }
  getPositionListHot(params) {
    return ajax.get({
      url: API.open.getPositionListHot,
      data: {
        data: params
      }
    })
  }

  // 获取资料列表
  getInformationList(params) {
    return ajax.get({
      url: API.open.informationList,
      data: {
        data: params
      }
    })
  }

  getInformationdetail(id) {
    return ajax.get({
      url: API.open.informationdetail.format(id)
    })
  }

  // 获取无权限的岗位列表
  getPositionList(params) {
    return ajax.get({
      url: API.open.getPositionList,
      data: {
        data: params
      }
    })
  }

  getOpenPositionDetail(id) {
    // 无权限限制岗位详情
    return ajax.get({
      url: API.open.getPositionDetial.format(id)
    })
  }

  getTagsList(params) {
    //  搜索标签的公共方法   search:[key: 'type', op: 'eq', val: '// someCondition']
    return ajax.get({
      url: API.open.getTagsList,
      data: {
        data: params
      }
    })
  }

  // 注册趋势
  statistics() {
    return ajax.get({
      url: API.open.statistics
    })
  }

  // 就业趋势
  employed(params) {
    return ajax.get({
      url: API.open.employed,
      data: {
        data: params
      }
    })
  }

  // 学校排行
  universityRank(params) {
    return ajax.get({
      url: API.open.universityRank,
      data: {
        data: params
      }
    })
  }

  // 活跃度排行
  activeRank(params) {
    return ajax.get({
      url: API.open.activeRank,
      data: {
        data: params
      }
    })
  }

  // 成长排行
  growthRank(params) {
    return ajax.get({
      url: API.open.growthRank,
      data: {
        data: params
      }
    })
  }

  message(params) {
    return ajax.get({
      url: API.open.message,
      data: {
        data: params
      }
    })
  }
  TreeList() {
    return ajax.get({
      url: API.open.TreeList
    })
  }

  getJsonTree(params) {
    return ajax.get({
      url: API.open.getJsonTree,
      data: {
        data: params
      }
    })
  }

  getApplyStudentList(id) {
    return ajax.get({
      url: API.open.getApplyStudentList.format(id)
    })
  }

  // 获取无权限的企业信息
  getOpenCompanyInfo(id) {
    return ajax.get({
      url: API.open.getOpenCompanyInfo.format(id)
    })
  }

  // 获取七牛Token
  getToken(params) {
    return ajax.get({
      url: API.open.getToken,
      data: params
    })
  }

  // 获取技能点详情
  getDifficultyIdDetail(id) {
    return ajax.get({
      url: API.open.getDifficultyIdDetail.format(id)
    })
  }

  // 获取需要某个知识点的岗位列表
  getDifficultyIdPositions(id) {
    return ajax.get({
      url: API.open.getDifficultyIdPositions.format(id)
    })
  }

  // 根据难度值知识点id获取该知识点信息
  getLvKnowInfo(params) {
    return ajax.get({
      url: API.open.getLvKnowInfo,
      data: {
        data: params
      }
    })
  }

  getDifficultyIdCourse(params) {
    return ajax.get({
      url: API.open.getDifficultyIdCourse,
      data: {
        data: params
      }
    })
  }

  // 企业列表
  companyInfo(params) {
    return ajax.get({
      url: API.open.companyInfo,
      data: {
        data: params
      }
    })
  }

  // 技能点详情-》相关知识库
  getDifficultyIdRepository(params) {
    return ajax.get({
      url: API.open.getDifficultyIdRepository,
      data: {
        data: params
      }
    })
  }

  getDifficultyIdStudents(params) {
    return ajax.get({
      url: API.open.getDifficultyIdStudents,
      data: {
        data: params
      }
    })
  }

  // 学校列表
  universityList(params) {
    return ajax.get({
      url: API.open.universityList,
      data: {
        data: params
      }
    })
  }

  // 院系列表
  departmentList(params, id) {
    return ajax.get({
      url: API.open.departmentList.format(id),
      data: {
        data: params
      }
    })
  }

  // 专业列表
  majorList(params, id) {
    return ajax.get({
      url: API.open.majorList.format(id),
      data: {
        data: params
      }
    })
  }

  // 班级列表
  classList(params, id) {
    return ajax.get({
      url: API.open.classList.format(id),
      data: {
        data: params
      }
    })
  }

  // 获取优惠活动详情
  recharge(id) {
    return ajax.get({
      url: API.open.recharge.format(id)
    })
  }

  // 人才列表
  personnelList(params) {
    return ajax.get({
      url: API.open.personnelList,
      data: {
        data: params
      }
    })
  }
  // 提现
  withdraw(params) {
    return ajax.post({
      url: API.open.withdraw,
      data: params
    })
  }
  // 提现(现在)
  withDraw(params) {
    return ajax.post({
      url: API.open.withDraw,
      data: params
    })
  }
  // 是否绑定微信
  binding(params) {
    return ajax.get({
      url: API.open.binding,
      data: {
        data: params
      }
    })
  }
  // 生成用户绑定微信二维码
  qrcode(params) {
    return ajax.get({
      url: API.open.qrcode,
      data: {
        data: params
      }
    })
  }
  // 发送解绑验证码
  sendCode(params) {
    return ajax.post({
      url: API.open.sendCode,
      data: params
    })
  }
  // 解绑微信
  unbinding(params) {
    return ajax.post({
      url: API.open.unbinding,
      data: params
    })
  }
}

export default new OpenService()



// WEBPACK FOOTER //
// ./src/service/open-service.js